import styled from 'styled-components';
import { MDBDropdown, MDBDropdownItem } from 'mdbreact';
import { MDBDropdownToggle } from '../_styledComponents/MDBDropdownToggle';
import { colors, MediaQuery, zIndexes } from '../../theme/style-helpers';
import TertiaryButton from '../../lib/ui/buttons/TertiaryButton';

export const Container = styled.div`
  display: grid;
  grid-gap: 20px;
  margin-bottom: 56px;
`;

export const StyledMDBDropdown = styled(MDBDropdown)`
  .dropdown-menu {
    padding: 24px;
    background-color: ${colors.LIGHT_GREY} !important;
    cursor: default;

    >div {
      display: grid;
      grid-gap: 24px;
    }
  }
`;

export const StyledMDBDropdownActions = styled(StyledMDBDropdown)`
  .dropdown-menu {
    left: -60px !important;
  }
`;

export const StyledMDBDropdownToggle = styled(MDBDropdownToggle)`
  display: grid !important;
  grid-gap: 8px;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;

  span {
    color: ${colors.BLACK};
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0em;
  }
`;

export const DropdownItem = styled(MDBDropdownItem)`
  display: flex !important;
  align-items: center !important;
  padding: 0px !important;
  cursor: pointer;

  &:enabled {
    color: ${colors.BLACK} !important;
  }

  &:disabled {
    color: ${colors.DARK_GREY} !important;
  }

  &:hover {
    path {
      fill: ${colors.BRAND_ORANGE};
    }

    p {
      color: ${colors.BRAND_ORANGE};
    }
  }
`;

export const DropdownItemIcon = styled.div`
  width: 20px;
  height: 20px;
  background: url( ${({ iconSrc }) => iconSrc});
  background-repeat: no-repeat;
  margin: 0;
  margin-right: 8px;
`;

export const TabsContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  width: max-content;
  grid-gap: 32px;
`;

export const TabContainer = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: center;
  padding: 0px 12px 14px;
  cursor: pointer;

  &:hover{
    color: ${colors.BRAND_ORANGE};
  }

  ${({ selected }) => selected && `
    color: ${colors.BRAND_ORANGE};
    border-bottom: 2px solid ${colors.BRAND_ORANGE};
  `};
`;

export const TitlesContainer = styled.div`
  display: grid;
  grid-gap: 16px;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0em;
  margin: 0px;

  ${MediaQuery.small`
    font-size: 3.6rem;
    font-weight: 500;
    line-height: 47px;
  `}
`;

export const SubTitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;

  ${MediaQuery.small`
    font-size: 16px;
    line-height: 24px;
  `}
`;

export const LegacyContainer = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-auto-flow: row;
  width: fit-content;
  align-items: center;

  >span {
    display: block;
  }

  ${MediaQuery.small`
    display: grid;
    grid-gap: 16px;
    grid-auto-flow: column;
    width: fit-content;
    align-items: center;
  `}
`;

export const Label = styled.span`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
`;

export const LegacyButtonGroup = styled.div`
  display: flex;

  button:first-child {
    margin-right: 16px;
  }
`;

export const LegacyButton = styled(TertiaryButton)`
  padding: 0px;
  text-decoration-line: underline;
  text-underline-offset: 6px;
`;

export const FiltersContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  padding: 32px 0px;
  border-top: 1px solid ${colors.COOL_GREY};

  input {
    width: 208px;
    height: 48px;

    ${MediaQuery.small`
      width: 258px;
    `};

    ${MediaQuery.large`
      width: 425px;
    `};
  }
`;

export const MobileActionsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${MediaQuery.medium`
    display: none;
  `};
`;

export const ActionsContainer = styled.div`
  display: none;

  ${MediaQuery.medium`
    display: grid;
    grid-gap: 24px;
    grid-auto-flow: column;
  `};
`;

export const ModalBoxStyle = {
  overlay: {
    backgroundColor: colors.BLACK + colors.OPACITY_70_ALPHA_HEX_SUFFIX,
    zIndex: zIndexes.MODAL,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    maxWidth: '90em',
    backgroundColor: colors.LIGHT_GREY,
    padding: '0px 0px 30px 0px',
    overflowY: 'auto',
    height: 'auto',
    maxHeight: '900px',
  },
};

export const ModalBody = styled.div`
  padding: 0px 48px;
`;

export const CloseContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 15px;

  img {
    cursor: pointer;
  }
`;

export const ModalTitlesContainer = styled.div`
  display: grid;
  grid-gap: 12px;
`;

export const ModalTitle = styled.div`
  font-size: 24px;
  font-weight: 500;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: center;

  ${MediaQuery.small`
    font-size: 28px;
    line-height: 36px;
  `};
`;

export const ModalSubTitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${colors.COOL_GREY};
  margin: 0;
`;

export const CategoriesContainer = styled.div`
  display: grid;
  grid-gap: 32px;
`;

export const CategoryContainer = styled.div`
  display: grid;
  grid-gap: 12px;
`;

export const BoxContainer = styled.div`
  padding: 20px 8px 20px 17px;
  background-color: ${({ bgColor }) => (bgColor || colors.WHITE)};
  max-width: ${({ maxWidth }) => maxWidth && maxWidth};
  max-height: ${({ maxHeight }) => (maxHeight || 'unset')};

  >div {
    padding-left: 3px;
    padding-top: 1px;
  }
`;

export const BoxInfo = styled.div`
  display: grid;
  grid-gap: 16px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.COOL_GREY};
    border-radius: 100px;
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${colors.DARK_GREY};
  }
`;

export const CategoryTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
`;

export const DownloadModalBody = styled.div`
  display: grid;
  justify-content: center;
  grid-gap: 20px;
  margin: 30px 0px;
`;

export const DatesContainer = styled.div`
  display: grid;
  grid-gap: 24px;
  grid-auto-flow: column;
`;

export const ButtonGroup = styled.div`
  display: grid;
  grid-gap: 32px;
  justify-content: center;
  flex-wrap: wrap;

  >button:first-child {
    outline: 1px solid ${colors.BLACK};
  }

  ${MediaQuery.small`
    grid-auto-flow: column;
  `};
`;

export const CommonButtonGroup = styled(ButtonGroup)`
  flex-direction: column-reverse;

  ${MediaQuery.medium`
    flex-direction: row;
  `};
`;

export const ModalContainer = styled.div`
  width: auto;
  max-width: 600px;
`;

export const ModalError = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px;
  font-size: 1.5rem;
  text-align: center;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 25px;

  svg {
    margin-right: 8px;
  }
`;

export const DropdownText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
`;
